{
  "version": 1,
  "asset_id": "85ab3722-6530-460d-82f8-d0a4ac8cb9b3",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/85ab3722-6530-460d-82f8-d0a4ac8cb9b3/sleeve-amateur-1.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/85ab3722-6530-460d-82f8-d0a4ac8cb9b3/sleeve-amateur-1.jpg",
  "original_filename": "sleeve-amateur-1.jpg",
  "size": 356867,
  "content_type": "image/png",
  "created_at": "2026-07-14T23:06:42Z"
}
